const setting = {
  passwordTitle: "Пароль",
  changePasswordBtn: "Изменить пароль",
  changePasswordTips:
    "Если вы забыли свой пароль или хотите его изменить, вы можете сделать это здесь. Мы отправим проверочный код на ваш зарегистрированную электронную почту, после подтверждения вашей личности, вы сможете сбросить пароль.",
  feedbackTitle: "Обратная связь",
  feedbackBtn: "Отправить Обратную связь",
  feedbackTips:
    "Чтобы мы могли лучше обслуживать вас, вы можете описать здесь свою проблему и отправить нам отзыв, и наша служба поддержки свяжется с вами в ближайшее время.",
  appearanceTitle: "Дисплей Внешнего вида",
  appearanceBtn: "Изменить дисплей",
  appearanceTips:
    "Мы выбираем для вас два режима внешнего вида, поэтому вы можете переключаться между темным и светлым режимами в соответствии с вашими предпочтениями.",
  changePassWordModalTitle: "Изменить пароль",
  changePassWordSameErrorTips: "Новый пароль, который вы ввели, совпадает с вашим старым паролем. Введите другой пароль",
  changePasswordCurrentErrorTips: "Ваш пароль неверный. Пожалуйста, попробуйте еще раз.",
  currentPasswordLabel: "Текущий пароль",
  newPasswordLabel: "Новый пароль",
  retypePasswordLabel: "Введите новый пароль еще раз",
  changePasswordSuccessTips: "Ваш пароль был успешно изменен.",
  changePasswordComfirmDiffErrorTips: "Пожалуйста, введите один и тот же пароль в оба поля.",
  forgotPassword: "Забыли пароль?",
  feedbackModalSubtitle: "Спасибо, что связались с нами и высказали свое мнение о продукте!",
  feedBackModalProductQuestion: "Какие проблемы вы хотите решить с помощью нашего продукта?",
  feedBackModalProductTypeSug: "Советы",
  feedBackModalProductTypeMem: "Вопросы об обслуживании участников",
  feedBackModalProductTypeFun: "Запрос функции",
  feedBackModalProductTypeReq: "Требования к продукту",
  feedBackModalProductTypeBug: "Отзыв об ошибках продукта",
  feedBackModalProductTypeIss: "Проблемы с производительностью",
  feedBackModalProductTypeRL: "Вопросы о регистрации и входе в систему",
  feedBackModalProductTypeRef: "Служба Возврата",
  feedBackModalProductTypeOth: "Другие",
  feedBackModalProductSelectQuestion: "Какие проблемы вы хотите решить с помощью нашего продукта?",
  feedBackModalProductContQuestion: "С какой проблемой вы столкнулись при использовании продукта?",
  feedBackModalAddImageBtn: "Добавить изображения",
  feedBackModalTips: "Примечание:",
  feedBackModalTipsCont: "Из-за разницы во времени глобальной службы поддержки мы ответим вам в течение 48 часов рабочего дня;",
  feedBackSuccessTips: "Отправить успешно",
  feedBackSuccessSubTips: "Решим вашу проблему в кратчайшие сроки",
  feedBackFailedTips: "Не удалось отправить",
  feedBackFailedSubTips: "Убедитесь, что ваше сетевое соединение работает, и отправьте еще раз",
  appearanceLightMode: "Светлый режим",
  appearanceDarkMode: "Темный режим",
  promotionModalTitle: "Льгота",
  promoItem: "Промо-товар",
  promoCode: "Промокод",
  discount: "Скидка",
  applyBtn: "Применить",
  applyPromotionErrorTips: "Ваш промокод недействителен",
};

export default setting;
